import(/* webpackMode: "eager" */ "/home/user/azagent2/_work/1/s/apps/dashboard/src/app/[locale]/pricesearch/page.tsx");
